import { SET_CREATE_CLIENT_FROM, SET_ACTIVE_TAB } from 'src/actions/actionTypes'

export const setCreateClientFrom = from => ({
  type: SET_CREATE_CLIENT_FROM,
  data: { from }
})

export const setActiveTab = tabName => ({
  type: SET_ACTIVE_TAB,
  tabName
})
